"use strict";

function GatewayQuestionsBind() {
  //Check to see if any of the gateway questions have a checked value of 'exit'
  var step1FormBtn = document.querySelector('.appointment-booking__step1-form-continue');
  var gatewayQuestions = document.querySelectorAll('.appointment-booking__current-health-info input');
  var gatewayAlert = document.querySelector('.appointment-booking__alert');
  gatewayQuestions.forEach(function (question) {
    question.addEventListener('change', function () {
      var i = [];
      gatewayQuestions.forEach(function (input) {
        if (input.checked) {
          var x = input.getAttribute('data-value');
          i.push(x);
          if (i.includes('exit')) {
            gatewayAlert.classList.add('active');
            step1FormBtn.setAttribute("style", "pointer-events:none;");
            step1FormBtn.classList.add('appointment-booking__btn-disabled');
          } else {
            gatewayAlert.classList.remove('active');
            step1FormBtn.setAttribute("style", "pointer-events:auto;");
            step1FormBtn.classList.remove('appointment-booking__btn-disabled');
          }
        }
      });
    });
  });
}
function ClearActiveCalendarDay() {
  //clear slected date on date change
  var activeSlot = document.querySelectorAll('.open-scheduler-epic__selected');
  if (activeSlot.length > 0) {
    activeSlot[0].classList.remove('open-scheduler-epic__selected');
  }
}
function CalendarOnSelect(data, elem) {
  //clear selected date
  var cal = document.querySelectorAll('.vanilla-calendar-date--active');
  cal.forEach(function (c) {
    c.classList.remove('vanilla-calendar-date--selected');
  });

  //set active date on select
  elem.classList.add('vanilla-calendar-date--selected');
  var dt = $(elem).data("calendar-data").date;
  var date = document.querySelectorAll('.appointment-booking-right-rail__times-container');

  //ie 11 support on foreach
  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  var patientType = GetPatientType();
  var visitTypeId = GetVisitTypeId(patientType);
  var hasSlot = new Boolean(false);
  date.forEach(function (d) {
    ClearActiveCalendarDay();

    //set active date
    if ($(d).data('date') == dt && $(d).data('visit-type') == visitTypeId) {
      d.classList.add('active');
      hasSlot = true;
    } else {
      d.classList.remove('active');
    }

    //set active display date on click
    d.addEventListener('click', function (e) {
      var displayDate = $('.appointment-booking-right-rail__times-container.active').first().data('display-date');
      if (displayDate) {
        $('#appointment-selected-display-date').text(displayDate);
      }
    });
  });
  if (hasSlot == false) {
    $('.appointment-booking__noslots').show();
  } else {
    $('.appointment-booking__noslots').hide();
  }
  hasSlot = false;
}
function GetPatientType() {
  var patientType;
  var patientTypeSelected = document.querySelectorAll('.appointment-booking__question-1 input');
  patientTypeSelected.forEach(function (input) {
    if (input.checked) {
      patientType = $(input).data('patient-visit-type');
    }
  });
  return patientType;
}
function GetVisitTypeId(patientType) {
  var visitTypeId;
  var visitTypeSelected = document.querySelectorAll('.appointment-booking__question-3 input');
  visitTypeSelected.forEach(function (input) {
    if (input.checked) {
      var visitTypeDataAttribute = patientType + "-patient-visit-type-id";
      visitTypeId = $(input).data(visitTypeDataAttribute);
    }
  });
  return visitTypeId;
}
function setActiveDateTime() {
  //ie 11 support for forEach
  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  $('#appointment-visittype-1').prop("checked", true);
  $('#appointment-new-doctor').prop("checked", true);
  var date = getUrlParams()["dt"];
  var slotIndex = getUrlParams()["si"];

  //Set Active Schedule Day
  var dates = document.querySelectorAll('.appointment-booking-right-rail__times-container');
  var hasSlot = new Boolean(false);
  var patientType = GetPatientType();
  var visitTypeId = GetVisitTypeId(patientType);
  dates.forEach(function (d) {
    var timeSlots = d.querySelectorAll('.appointment-booking-right-rail__times-list ul li');
    if ($(d).data('date') == date && $(d).data('visit-type') == visitTypeId) {
      d.classList.add('active');
      hasSlot = true;

      //Set Active Slot
      if (timeSlots) {
        if (slotIndex) {
          timeSlots[slotIndex].classList.add('open-scheduler-epic__selected');

          //Set Default Value For Active Slot
          var time = $(timeSlots[slotIndex]).text();
          $('#appointment-selected-time').text(time);
        }
      }
    }

    //When a Slot is Selected Set the Value
    timeSlots.forEach(function (ts) {
      ts.addEventListener('click', function (e) {
        e.preventDefault();
        var time = $(ts).text();
        $('#appointment-selected-time').text(time);
      });
    });
  });
  if (hasSlot == false) {
    $('.appointment-booking__noslots').show();
  } else {
    $('.appointment-booking__noslots').hide();
  }
  hasSlot = false;
}
function getUrlParams() {
  var params = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    params[key] = value;
  });
  return params;
}
function BindVisitTypes() {
  var hasSlot = new Boolean(false);
  var patientType = GetPatientType();
  var visitTypeId = GetVisitTypeId(patientType);
  var dates = document.querySelectorAll('.appointment-booking-right-rail__times-container');
  var patientTypeSelected = document.querySelectorAll('.appointment-booking__question-1 input');
  patientTypeSelected.forEach(function (input) {
    input.addEventListener('click', function (e) {
      var selectedPatientType = $(this).data('patient-visit-type');
      var selectedVisitTypeId = GetVisitTypeId(selectedPatientType);
      if (visitTypeId != selectedVisitTypeId) {
        ClearActiveCalendarDay();
      }
      dates.forEach(function (d) {
        //get the selected date from the query string the first time when calendar isnt created. Otherwise, get it fromt the calendar
        var selectedDate;
        if ($('.vanilla-calendar-date--selected').length > 0) {
          selectedDate = $('.vanilla-calendar-date--selected').data("calendar-data").date;
        } else {
          selectedDate = getUrlParams()["dt"];
        }

        //set active date
        if ($(d).data('date') == selectedDate && $(d).data('visit-type') == selectedVisitTypeId) {
          d.classList.add('active');
          hasSlot = true;
        } else {
          d.classList.remove('active');
        }
      });
      if (hasSlot == false) {
        $('.appointment-booking__noslots').show();
      } else {
        $('.appointment-booking__noslots').hide();
      }
      hasSlot = false;
    });
  });
  var visitTypeSelected = document.querySelectorAll('.appointment-booking__question-3 input');
  visitTypeSelected.forEach(function (input) {
    input.addEventListener('click', function (e) {
      ClearActiveCalendarDay();
      var selectedPatientType = GetPatientType();
      var selectedVisitTypeId = $(this).data(selectedPatientType + '-patient-visit-type-id');
      dates.forEach(function (d) {
        //get the selected date from the query string the first time when calendar isnt created. Otherwise, get it fromt the calendar
        var selectedDate;
        if ($('.vanilla-calendar-date--selected').length > 0) {
          selectedDate = $('.vanilla-calendar-date--selected').data("calendar-data").date;
        } else {
          selectedDate = getUrlParams()["dt"];
        }

        //set active date
        if ($(d).data('date') == selectedDate && $(d).data('visit-type') == selectedVisitTypeId) {
          d.classList.add('active');
          hasSlot = true;
        } else {
          d.classList.remove('active');
        }
      });
      if (hasSlot == false) {
        $('.appointment-booking__noslots').show();
      } else {
        $('.appointment-booking__noslots').hide();
      }
      hasSlot = false;
      if ($(input).data('is-telehealth') == "True") {
        $('.appointment-booking__map').hide();
        $('.appointment-details__information-address').hide();
        $('.appointment-details__information-telehealth').show();
      } else {
        $('.appointment-booking__map').show();
        $('.appointment-details__information-address').show();
        $('.appointment-details__information-telehealth').hide();
      }

      //load new questions if current visit type is not equal to the one selected
      var openSchedulerId = $('#appointment-booking-form-questions-inner-container').data("open-scheduler-id");
      var apiUrl = "/api/sitecore/Appointment/QuestionsPartial?" + "OpenSchedulerId=" + openSchedulerId + "&VisitTypeId=" + selectedVisitTypeId + "&PatientType=" + patientType;
      var questionsOuterContainer = $('#appointment-booking-form-questions-outer-container');
      var questionsInnerContainer = $('#appointment-booking-form-questions-inner-container');
      var gatewayAlert = document.querySelector('.appointment-booking__alert');
      gatewayAlert.classList.remove("active");
      var step1FormBtn = document.querySelector('.appointment-booking__step1-form-continue');
      step1FormBtn.classList.add('appointment-booking__btn-disabled');
      makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
        if (isNetworkSuccess) {
          $(questionsInnerContainer).remove();
          var $container = $(questionsOuterContainer);
          $container.append(xhttp.responseText);
          step1FormBtn.classList.remove('appointment-booking__btn-disabled');
          GatewayQuestionsBind();
        }
      });
    });
  });
}
function BookAppointment() {
  //ie 11 support for forEach
  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  var patientType = GetPatientType();
  var visitTypeId = GetVisitTypeId(patientType);
  var isTelehealth;
  var visitTypeSelected = document.querySelectorAll('.appointment-booking__question-3 input');
  visitTypeSelected.forEach(function (input) {
    if (input.checked) {
      isTelehealth = $(input).data('is-telehealth');
    }
  });
  var genderSelected;
  var genderChecked = document.querySelectorAll('.appointment-booking__gender-container input');
  genderChecked.forEach(function (input) {
    if (input.checked) {
      genderSelected = input.value;
    }
  });
  var departmentId;
  var multipleDepartments = $('#openSchedulerEpicDropdownPhysicianAppointment');
  if (multipleDepartments.length) {
    departmentId = $('#openSchedulerEpicDropdownPhysicianAppointment').find(":selected").data("provider-department-id");
  } else {
    departmentId = $('#appointment-booking-one-department').data("provider-department-id");
  }
  var contextId = getUrlParams()["id"];
  var departmentId = departmentId;
  var physicianId = contextId;
  var visitTypeId = visitTypeId;
  var date = $('.open-scheduler-epic__selected').data('date');
  var time = $('.open-scheduler-epic__selected').data('time');
  var comments = $('#appointment-reason').val();
  var groupNumber = $('#appointment-booking-group-number').val();
  var insuranceName = $('#appointment-booking-insurance-name').val();
  var MemberNumber = $('#appointment-booking-memberid').val();
  var payorId = $('#appointment-booking-insurance').find(":selected").data("payorid");
  var SubscriberDateOfBirth = $('#appointment-booking-subscriber-sub-date-birth').val();
  var subscriberName = $('#appointment-booking-subscriber-name').val();
  var firstName = $('#appointment-booking-first-name').val();
  var lastName = $('#appointment-booking-last-name').val();
  var email = $('#appointment-booking-email').val();
  var dateOfBirth = $('#appointment-booking-dob').val();
  var gender = genderSelected;
  var street = $('#appointment-booking-street').val();
  var city = $('#appointment-booking-city').val();
  var state = $('#appointment-booking-state').val();
  var zipcode = $('#appointment-booking-zip').val();
  var phoneNumber = $('#appointment-booking-phone').val();
  var isTelehealth = isTelehealth;
  var apiUrl = "/api/sitecore/Appointment/ScheduleAppointment?" + "Captcha=" + grecaptcha.getResponse() + "&DepartmentId=" + departmentId + "&PhysicianId=" + physicianId + "&VisitTypeId=" + visitTypeId + "&Date=" + date + "&Time=" + time + "&Comments=" + comments + "&GroupNumber=" + groupNumber + "&InsuranceName=" + insuranceName + "&MemberNumber=" + MemberNumber + "&PayorID=" + payorId + "&SubscriberDateOfBirth=" + SubscriberDateOfBirth + "&SubscriberName=" + subscriberName + "&FirstName=" + firstName + "&LastName=" + lastName + "&Email=" + email + "&DateOfBirth=" + dateOfBirth + "&Gender=" + gender + "&Street=" + street + "&City=" + city + "&State=" + state + "&Zipcode=" + zipcode + "&PhoneNumber=" + phoneNumber + "&IsTelehealth=" + isTelehealth;
  var ScheduleAppointmentOuterContainer = $('#appointment-booking-form-outer-container');
  var ScheduleAppointmentInnerContainer = $('#appointment-booking-form-inner-container');
  if (grecaptcha && grecaptcha.getResponse().length > 0) {
    makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
      if (isNetworkSuccess) {
        $(ScheduleAppointmentInnerContainer).remove();
        var $container = $(ScheduleAppointmentOuterContainer);
        $container.append(xhttp.responseText);
        var appointmentStep = document.querySelectorAll('.appointment-booking__step');
        appointmentStep[2].classList.add('active');
        $('.appointment-details__confirmation-text').show();
      }
    });
  }
}
function appointmentBookingInit() {
  //ie 11 support for forEach
  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  var appointmentNav = document.querySelectorAll('.appointment-booking__navigation li');
  var appointmentStep = document.querySelectorAll('.appointment-booking__step');
  var step1FormBtn = document.querySelector('.appointment-booking__step1-form-continue');
  var step2FormBtn = document.querySelector('.appointment-booking__step2-form-continue');
  var step1Question1passed = false;
  var step1Question2passed = false;
  var step1Question3passed = false;
  var gatewayPassed = false;
  var timePassed = false;
  var personalInformationPassed = false;
  var genderPassed = false;
  var addressPassed = false;
  var statePassed = false;
  var insurancePassed = false;
  var notListedPassed = true;
  var allFieldsPassed = false;
  var addressPhone = false;
  var addressZip = false;
  var addressFields = false;
  var personalInfoEmail = false;
  var personalInfoDOB = false;
  var personalInfoNames = false;
  var insuranceDOB = false;
  var insuranceAllOtherFields = false;
  openSchedulerAppointmentPhysicianInit();
  BindVisitTypes();
  var appointmentTextarea = document.querySelectorAll('.appointment-booking__step textarea');
  var appointmentInputs = document.querySelectorAll('.appointment-booking__step input');
  var appointmentSelects = document.querySelectorAll('.appointment-booking__step select');
  appointmentTextarea.forEach(function (input) {
    input.addEventListener("input", function () {
      if ($(this).closest('div').find('.appointment-booking__question-error').hasClass('active')) {
        $(this).closest('div').find('.appointment-booking__question-error').removeClass('active');
      }
      if ($(this).hasClass('error')) {
        $(this).removeClass('error');
      }
    });
  });
  appointmentInputs.forEach(function (input) {
    input.addEventListener("input", function () {
      if (input.getAttribute('name') == 'appointment-gender') {
        if ($(this).closest('.appointment-booking__gender-container').find('.appointment-booking__question-error').hasClass('active')) {
          $(this).closest('.appointment-booking__gender-container').find('.appointment-booking__question-error').removeClass('active');
        }
        if ($(this).hasClass('error')) {
          $(this).removeClass('error');
        }
      } else if (input.getAttribute('data-group') == 'covid-question') {
        if ($(this).closest('fieldset').find('.appointment-booking__question-error').hasClass('active')) {
          $(this).closest('fieldset').find('.appointment-booking__question-error').removeClass('active');
        }
        if ($(this).hasClass('error')) {
          $(this).removeClass('error');
        }
      } else {
        if ($(this).closest('div').find('.appointment-booking__question-error').hasClass('active')) {
          $(this).closest('div').find('.appointment-booking__question-error').removeClass('active');
        }
        if ($(this).hasClass('error')) {
          $(this).removeClass('error');
        }
      }
    });
  });
  appointmentSelects.forEach(function (input) {
    input.addEventListener("input", function () {
      if ($(this).closest('div').find('.appointment-booking__question-error').hasClass('active')) {
        $(this).closest('div').find('.appointment-booking__question-error').removeClass('active');
      }
      if ($(this).hasClass('error')) {
        $(this).removeClass('error');
      }
    });
  });
  function openSchedulerAppointmentPhysicianInit() {
    if ($('.appointment-details').length > 0) {
      if ($("#openSchedulerEpicDropdownPhysicianAppointment").length > 0) {
        var AppointmentContainer = document.querySelector('.appointment');
        var AppointmentInnerContainer = document.querySelector('.appointment-booking');
        if ($(".custom-select-dropdown-open-scheduler").length > 0) {
          var x, i, j, l, ll, selElmnt, a, b, c;
          /*look for any elements with the class "custom-select":*/
          x = document.getElementsByClassName("custom-select-dropdown-open-scheduler");
          l = x.length;
          for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            ll = selElmnt.length;
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.id = selElmnt.options[selElmnt.selectedIndex].id;
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 1; j < ll; j++) {
              /*for each option in the original select element,
              create a new DIV that will act as an option item:*/
              c = document.createElement("DIV");
              c.innerHTML = selElmnt.options[j].innerHTML;
              c.id = selElmnt.options[j].id;
              c.addEventListener("click", function (e) {
                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                var selectedOption = document.getElementById("content-" + this.id);
                $(".dropdown-select-content > div").removeClass("active");
                $(selectedOption).addClass("active");
                for (i = 0; i < sl; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                      y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                  }
                }
                h.click();

                //Disable subsequent clicks
                x[0].setAttribute("style", "pointer-events:none;");

                //Get Scehdule Data

                //need to force the updated select option on click
                $('#openSchedulerEpicDropdownPhysicianAppointment').get(0).selectedIndex = i;
                var departmentId = $('#openSchedulerEpicDropdownPhysicianAppointment').find(":selected").data("provider-department-id");
                var physicianId = $('#openSchedulerEpicDropdownPhysicianAppointment').find(":selected").data("physician-id");
                var dt = $('#openSchedulerEpicDropdownPhysicianAppointment').find(":selected").data("dt");
                var apiUrl = "/api/sitecore/Appointment/AppointmentPartial?PhysicianId=" + physicianId + "&DepartmentId=" + departmentId + "&Date=" + dt;
                makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
                  if (isNetworkSuccess) {
                    AppointmentInnerContainer.remove();
                    var $container = $(AppointmentContainer);
                    $container.append(xhttp.responseText);
                    setActiveDateTime();
                    appointmentBookingInit();

                    //re-active captcha
                    if ($('#physicianappointmentcaptcha').length) {
                      var siteKey = $('#physicianappointmentcaptcha').data('sitekey');
                      grecaptcha.render('physicianappointmentcaptcha', {
                        'sitekey': '' + siteKey + ''
                      });
                    }
                  }
                });
              });
              b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function (e) {
              /*when the select box is clicked, close any other select boxes,
              and open/close the current select box:*/
              e.stopPropagation();
              closeAllSelect(this);
              this.nextSibling.classList.toggle("select-hide");
              this.classList.toggle("select-arrow-active");
            });
          }
          function closeAllSelect(elmnt) {
            /*a function that will close all select boxes in the document,
            except the current select box:*/
            var x,
              y,
              i,
              xl,
              yl,
              arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            xl = x.length;
            yl = y.length;
            for (i = 0; i < yl; i++) {
              if (elmnt == y[i]) {
                arrNo.push(i);
              } else {
                y[i].classList.remove("select-arrow-active");
              }
            }
            for (i = 0; i < xl; i++) {
              if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
              }
            }
          }
          /*if the user clicks anywhere outside the select box,
          then close all select boxes:*/
          document.addEventListener("click", closeAllSelect);
        }
      }
    }
  }
  function errors() {
    var question1Checked = document.querySelectorAll('.appointment-booking__question-1 input');
    var question2Checked = document.querySelector('.appointment-booking__question-2 textArea');
    var question2CheckedValue = question2Checked.value;
    var question3Checked = document.querySelectorAll('.appointment-booking__question-3 input');
    var error1 = document.querySelector('.appointment-booking__question-1 .appointment-booking__question-error');
    var error2 = document.querySelector('.appointment-booking__question-2 .appointment-booking__question-error');
    var error3 = document.querySelector('.appointment-booking__question-3 .appointment-booking__question-error');
    question1Checked.forEach(function (input) {
      if (input.checked) {
        step1Question1passed = true;
      }
    });
    if (step1Question1passed == true) {
      error1.classList.remove('active');
    } else {
      error1.classList.add('active');
    }

    //Questoin 2 check
    if (question2CheckedValue.length > 1) {
      error2.classList.remove('active');
      document.querySelector('.appointment-booking__question-2 textarea').classList.remove('error');
      step1Question2passed = true;
    } else {
      error2.classList.add('active');
      document.querySelector('.appointment-booking__question-2 textarea').classList.add('error');
      step1Question2passed = false;
    }

    //Question 3 check
    question3Checked.forEach(function (input) {
      if (input.checked) {
        step1Question3passed = true;
      }
    });
    if (step1Question3passed == true) {
      error3.classList.remove('active');
    } else {
      error3.classList.add('active');
    }

    //Check to make sure all the gateway questions are answered
    var gatewayQuestionsCheck = document.querySelectorAll('.appointment-booking__current-health-info fieldset');
    var a = 0;
    gatewayQuestionsCheck.forEach(function (question) {
      var test = question.querySelectorAll('input');
      test.forEach(function (fdsa) {
        if (fdsa.checked == false) {
          fdsa.parentElement.querySelector('.appointment-booking__question-error').classList.add('active');
        }
      });
      for (var l = 0, length = test.length; l < length; l++) {
        if (test[l].checked) {
          var x = test[l].getAttribute('data-value');
          if (x !== 'exit') {
            test[l].parentElement.querySelector('.appointment-booking__question-error').classList.remove('active');
            a++;
          }
        }
      }
      if (a == gatewayQuestionsCheck.length) {
        gatewayQuestionsCheck.forEach(function (error) {
          error.querySelector('.appointment-booking__question-error').classList.remove('active');
        });
        gatewayPassed = true;
      }
    });

    //Check to see if a time is selected in the right rail
    var timeSlot = document.querySelectorAll('.appointment-booking-right-rail__times-list ul li');
    var timeSlotError = document.querySelector('.appointment-booking-right-rail__times .appointment-booking__question-error');
    timeSlot.forEach(function (time) {
      if (time.classList.contains('open-scheduler-epic__selected')) {
        timePassed = true;
      }
    });
    if (timePassed == true) {
      timeSlotError.classList.remove('active');
    } else {
      timeSlotError.classList.add('active');
    }
  }
  var timeSlot = document.querySelectorAll('.appointment-booking-right-rail__times-list ul li');
  timeSlot.forEach(function (time) {
    time.addEventListener('click', function () {
      timeSlot.forEach(function (time) {
        time.classList.remove('open-scheduler-epic__selected');
      });
      time.classList.add('open-scheduler-epic__selected');
    });
  });
  GatewayQuestionsBind();
  function errorsStep2(e) {
    var piTop = document.querySelectorAll('.appointment-booking__pi-top input');
    var genderChecked = document.querySelectorAll('.appointment-booking__gender-container input');
    var state = document.getElementById('appointment-booking-state');
    var address = document.querySelectorAll('.appointment-booking__address-info input');
    var captchaElement = document.getElementById('physicianappointmentcaptcha');
    var captchaError = document.querySelector('.appointment-booking__captcha-error');

    //Personal Information top inputs error check
    piTop.forEach(function (input) {
      var piTopValue = input.value;
      if (input.getAttribute('type') == 'email') {
        var re = new RegExp(input.getAttribute('data-email-re'), 'im');
        if (input.value.match(re)) {
          input.nextElementSibling.classList.remove('active');
          input.classList.remove('error');
          personalInfoEmail = true;
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          personalInfoEmail = false;
        }
      } else if (input.getAttribute('name') == 'appointment-booking-dob') {
        var dateRe = new RegExp(input.getAttribute('data-date-re'));
        var inputValue = input.value;
        if (inputValue.match(dateRe)) {
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1;
          var yyyy = today.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
          if (mm < 10) {
            mm = '0' + mm;
          }
          var today = yyyy + '-' + mm + '-' + dd;
          var splitDate1 = inputValue.split('/');
          var year1 = splitDate1[2];
          var month1 = splitDate1[0];
          var day1 = splitDate1[1];
          var enteredDate = year1 + '-' + month1 + '-' + day1;
          var enteredDate1 = new Date(enteredDate);
          var today1 = new Date(today);
          var dateInPast = function dateInPast(enteredDate1, today1) {
            if (enteredDate1.setHours(0, 0, 0, 0) <= today1.setHours(0, 0, 0, 0)) {
              input.nextElementSibling.classList.remove('active');
              input.classList.remove('error');
              personalInfoDOB = true;
            } else {
              input.nextElementSibling.classList.add('active');
              input.classList.add('error');
              personalInfoDOB = false;
            }
          };
          dateInPast(enteredDate1, today1);
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          personalInfoDOB = false;
        }
      } else {
        if (piTopValue.length > 1) {
          var nameRe = new RegExp(input.getAttribute('data-name-re'));
          if (!nameRe.test(piTopValue)) {
            input.nextElementSibling.classList.add('active');
            input.classList.add('error');
            personalInfoNames = false;
          } else {
            input.nextElementSibling.classList.remove('active');
            input.classList.remove('error');
            personalInfoNames = true;
          }
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          personalInfoNames = false;
        }
      }
      if (personalInfoEmail == true && personalInfoDOB == true && personalInfoNames == true) {
        personalInformationPassed = true;
      }
    });
    //Gender radio inputs error check
    var gError = document.querySelector('.appointment-booking__gender-container .appointment-booking__question-error');
    genderChecked.forEach(function (input) {
      if (input.checked) {
        genderPassed = true;
      }
    });
    if (genderPassed == true) {
      gError.classList.remove('active');
    } else {
      gError.classList.add('active');
    }

    //State drop down error check

    if (!state.value == "") {
      state.nextElementSibling.classList.remove('active');
      state.classList.remove('error');
      statePassed = true;
    } else {
      state.nextElementSibling.classList.add('active');
      state.classList.add('error');
      statePassed = false;
    }
    address.forEach(function (input) {
      var addressValue = input.value;
      if (input.getAttribute('type') == 'tel') {
        var phoneRe = new RegExp(input.getAttribute('data-phone-re'), 'im');
        if (input.value.match(phoneRe)) {
          input.nextElementSibling.classList.remove('active');
          input.classList.remove('error');
          addressPhone = true;
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          addressPhone = false;
        }
      } else if (input.getAttribute('data-type') == 'zipcode') {
        var zipRe = new RegExp(input.getAttribute('data-zipcode-re'));
        if (input.value.match(zipRe)) {
          input.nextElementSibling.classList.remove('active');
          input.classList.remove('error');
          addressZip = true;
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          addressZip = false;
        }
      } else {
        if (addressValue.length > 1) {
          input.nextElementSibling.classList.remove('active');
          input.classList.remove('error');
          addressFields = true;
        } else {
          input.nextElementSibling.classList.add('active');
          input.classList.add('error');
          addressFields = false;
        }
      }
    });
    if (addressPhone == true && addressZip == true && addressFields == true && statePassed == true) {
      addressPassed = true;
    }

    //Insurance information check
    var iCompany = document.getElementById('appointment-booking-insurance');
    if (!iCompany.value == '') {
      iCompany.nextElementSibling.classList.remove('active');
      iCompany.classList.remove('error');
    } else {
      iCompany.nextElementSibling.classList.add('active');
      iCompany.classList.add('error');
    }
    var allInsFieldsShow = document.querySelector('.appointment-booking__all-other-fields');
    var allInsFields = document.querySelectorAll('.appointment-booking__all-other-fields input');
    if (allInsFieldsShow.classList.contains('show')) {
      allInsFields.forEach(function (input) {
        if (input.getAttribute('name') == 'appointment-booking-subscriber-sub-date-birth') {
          var dateRe1 = new RegExp(input.getAttribute('data-subdate-re'));
          var allFieldValue = input.value;
          if (allFieldValue.match(dateRe1)) {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
              dd = '0' + dd;
            }
            if (mm < 10) {
              mm = '0' + mm;
            }
            var today = yyyy + '-' + mm + '-' + dd;
            var splitDate1 = allFieldValue.split('/');
            var year1 = splitDate1[2];
            var month1 = splitDate1[0];
            var day1 = splitDate1[1];
            var enteredDate = year1 + '-' + month1 + '-' + day1;
            var enteredDate1 = new Date(enteredDate);
            var today1 = new Date(today);
            var dateInPast = function dateInPast(enteredDate1, today1) {
              if (enteredDate1.setHours(0, 0, 0, 0) <= today1.setHours(0, 0, 0, 0)) {
                input.nextElementSibling.classList.remove('active');
                input.classList.remove('error');
                insuranceDOB = true;
              } else {
                input.nextElementSibling.classList.add('active');
                input.classList.add('error');
                insuranceDOB = false;
              }
            };
            dateInPast(enteredDate1, today1);
          } else {
            input.nextElementSibling.classList.add('active');
            input.classList.add('error');
            insuranceDOB = false;
          }
        } else {
          if (!input.value == '') {
            input.nextElementSibling.classList.remove('active');
            input.classList.remove('error');
            insuranceAllOtherFields = true;
          } else {
            input.nextElementSibling.classList.add('active');
            input.classList.add('error');
            insuranceAllOtherFields = false;
          }
        }
      });
      if (insuranceDOB == true && insuranceAllOtherFields == true) {
        allFieldsPassed = true;
      }
    }
    var notListed = document.querySelector('.appointment-booking__insurance-name');
    var notListedInput = document.querySelector('.appointment-booking__insurance-name input');
    if (notListed.classList.contains('show')) {
      if (notListedInput.value.length > 1) {
        notListedInput.nextElementSibling.classList.remove('active');
        notListedInput.classList.remove('error');
        notListedPassed = true;
      } else {
        notListedInput.nextElementSibling.classList.add('active');
        notListedInput.classList.add('error');
        notListedPassed = false;
      }
    }
    if (captchaElement) {
      if (!grecaptcha.getResponse().length > 0) {
        captchaError.classList.add('active');
      } else {
        captchaError.classList.remove('active');
      }
    }
    if (notListedPassed == true && allFieldsPassed == true) {
      insurancePassed = true;
    }
  }

  //Check to see what value the Insurance drop down has
  var iCompany = document.getElementById('appointment-booking-insurance');
  var iName = document.querySelector('.appointment-booking__insurance-name');
  var allOtherFields = document.querySelector('.appointment-booking__all-other-fields');
  if (iCompany) {
    iCompany.addEventListener('change', function (e) {
      //If dropdown has Not Insured as value hide all the inputs
      if (iCompany.value.toLowerCase() == 'not insured') {
        iName.classList.remove('show');
        allOtherFields.classList.remove('show');
        insurancePassed = true;
        //If the dropdown has Not Listed as value, show the name field and rest of fields
      } else if (iCompany.value.toLowerCase() == '') {
        iName.classList.remove('show');
        allOtherFields.classList.remove('show');
      } else if (iCompany.value.toLowerCase() == 'not listed') {
        iName.classList.add('show');
        allOtherFields.classList.add('show');
        //If dropdown has an insurance company as value, only show the rest of the fields, not the name
      } else {
        iName.classList.remove('show');
        allOtherFields.classList.add('show');
      }
    });
  }

  //Check for errors on click of the step navigation and change classes if passed
  var nav0 = document.querySelector('.appointment-booking__step0-continue-nav');
  var nav1 = document.querySelector('.appointment-booking__step1-continue-nav');
  var nav2 = document.querySelector('.appointment-booking__step2-continue-nav');
  var appointmentDetailsSelect = document.querySelector('.appointment-booking-right-rail .appointment-details__locations');
  var appoinmentRailCalendar = document.querySelector('.appointment-booking-right-rail__calendar');
  var appointmentRailTimes = document.querySelector('.appointment-booking-right-rail__times');
  var appointmentRailInformation = document.querySelector('.appointment-booking-right-rail .appointment-details__information');
  appointmentDetailsSelect.classList.add('active');
  appoinmentRailCalendar.classList.add('active');
  appointmentRailTimes.classList.add('active');

  //Selecting Back, just reload the page
  function navigationBack(event) {
    window.location.reload();
  }

  //Click step 1 continue button
  if (step1FormBtn) {
    step1FormBtn.addEventListener('click', function (e) {
      errors(e);
      if (step1FormBtn.classList.contains('appointment-booking__btn-disabled')) {
        e.preventDefault();
      } else {
        if (step1Question1passed == true && step1Question2passed == true && step1Question3passed == true && gatewayPassed == true && timePassed == true) {
          if (appointmentDetailsSelect) {
            appointmentDetailsSelect.classList.remove('active');
          }
          if (appoinmentRailCalendar) {
            appoinmentRailCalendar.classList.remove('active');
          }
          if (appointmentRailTimes) {
            appointmentRailTimes.classList.remove('active');
          }
          if (appointmentRailInformation) {
            appointmentRailInformation.classList.add('active');
          }
          appointmentStep.forEach(function (step) {
            step.classList.remove('active');
          });
          appointmentStep[1].classList.add('active');
          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
          appointmentNav.forEach(function (item) {
            item.classList.remove('active');
          });
          nav0.classList.add('complete');
          nav1.classList.add('active');
          nav0.addEventListener('click', navigationBack, true);
          //Hide dropdown in the right rail
          step1FormBtn.classList.add('hide');
          step2FormBtn.classList.remove('hide');
        } else {
          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
        }
      }
    });
  }
  if (step2FormBtn) {
    step2FormBtn.addEventListener('click', function (e) {
      errorsStep2();
      if (personalInformationPassed == true && genderPassed == true && addressPassed == true && insurancePassed == true && grecaptcha.getResponse().length > 0) {
        var rightRail = document.querySelector('.appointment-booking-right-rail');
        rightRail.classList.add('hide');
        appointmentStep.forEach(function (step) {
          step.classList.remove('active');
        });
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
        appointmentNav.forEach(function (item) {
          item.classList.remove('active');
          item.classList.remove('complete');
        });
        nav0.classList.add('complete');
        nav1.classList.add('complete');
        nav2.classList.add('active');
        nav0.removeEventListener('click', navigationBack, true);
        step2FormBtn.classList.add('hide');
        BookAppointment();
      } else {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }
}
$(document).ready(function () {
  var isAppointmentPage = document.querySelector('.appointment-booking');
  if (isAppointmentPage) {
    setActiveDateTime();
    appointmentBookingInit();
  }
});